module.exports = __webpack_public_path__ + "img/key.801e1c52.png";